















































































import { Vue, Component, Prop, Mixins, Provide, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { validTime, maxDate, minDate } from "@/mixins/DateValidators";

import DeviceSearchMixin from "@/components/video-reporting/deviceSearchMixin";

import { Select } from "@sureview/vuejs-sv-dropdown";
import DatePicker from "@sureview/vuejs-datepicker";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import DragDropUpload from "@/components/form/DragDropUpload.vue";
import BulkDeviceSearchRow from "./BulkDeviceSearchRow.vue";

import videoReportingApi from "@/services/api.videoReporting";
import { DeviceSearchModel, VideoReportRequest } from "@/store/video-reporting/types";

@Component({
	components: {
		"sv-select": Select,
		"date-picker": DatePicker,
		"drag-drop-upload": DragDropUpload,
		"bulk-device-search-row": BulkDeviceSearchRow,
		"vue-perfect-scrollbar": VuePerfectScrollbar
	},
	validations: {
		bulkSearchRequest: {
			required,
			minLength: minLength(1),
			$each: {
				deviceId: {
					required
				},
				date: {
					required,
					minDate: minDate(new Date(2016, 1, 1)), // Arbitrary minimum date
					maxDate: maxDate(new Date())
				}
			}
		}
	}
})
export default class BulkDeviceSearch extends Mixins(DeviceSearchMixin, validationMixin) {
	@Prop({ type: Boolean, default: false }) private disabled: boolean;
	@Prop({ type: Object }) private videoReportRequest: VideoReportRequest;

	private readonly csvMimeTypes = [
		"text/csv",
		"application/csv",
		"application/vnd.ms-excel",
		"text/x-csv",
		"text/plain"
	];

	private hasUploaded: boolean = false;
	private bulkSearchRequest: DeviceSearchModel[] = null;
	private bulkUploadTemplateUrl: string = "";

	@Watch("$v.$invalid", { immediate: true })
	private onValidationStateChanged(newVal) {
		this.$emit("input", newVal ? null : this.bulkSearchRequest);
	}

	private onInvalidFileDropped(file: File) {
		this.$notify({
			type: "error",
			title: "Video Reporting - Bulk Upload",
			text: `Unable to upload the file provided (${file.name}) as it was not a valid CSV file`
		});
	}

	private onCancelBulkSearch() {
		this.hasUploaded = false;
		this.bulkSearchRequest = null;
	}

	private async onBulkDeviceSearchUploaded(file: File, searchResults: any) {
		this.hasUploaded = true;
		this.bulkSearchRequest = searchResults;
		await this.$nextTick();

		this.$v.$touch();
	}

	private async uploadBulkDeviceSearch(file: File, progressHandler: (number) => void) {
		return await videoReportingApi.uploadBulkDeviceSearch(file, progressHandler);
	}

	private created() {
		let templateData = 'DeviceName,Date (YYYY-MM-DD HH:mm:ss),MaxDuration\n"Device Name",2019-12-31 23:59:59,10';
		var bulkUploadTemplateBlob = new Blob([templateData], { type: "text/csv" });
		this.bulkUploadTemplateUrl = window.URL.createObjectURL(bulkUploadTemplateBlob);
	}

	private destroyed() {
		window.URL.revokeObjectURL(this.bulkUploadTemplateUrl);
	}
}
